export default function formatAmount(value, digits = 2) {
  try {
    if (value === null || value === undefined || value === "") return "";
    const str = String(value).replace(/,/g, "").trim();
    const num = Number(str);
    if (isNaN(num)) return value;
    return num.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
  } catch (e) {
    return value;
  }
}
